module.exports = __webpack_public_path__ + "img/749DCBE9905D384E.ba244cf2.png";